import React, { useState } from "react";
import { FormGroup, Button, Label, Input, Container } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { CreateRoomType } from "../../apis/RoomType";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { AxiosError } from "axios";

const AddRoomType = () => {
  const [isChecked, setIsChecked] = useState(true);
  const [roomTypeName, setRoomTypeName] = useState({
    en: "",
    ar: "",
  });
  const [uploadedImage, setUploadedImage] = useState(null);
  const [fileError, setFileError] = useState(false);
  const [iconPreview, setIconPreview] = useState(null);

  const navigate = useNavigate();

  const breadcrumbItems = [
    { title: "Tables", link: "/" },
    { title: "Data Tables", link: "#" },
  ];

  const handleImageUpload = (e) => {
    const file = e.target.files[0];

    if (!file) {
      setUploadedImage(null);
      setFileError(null);
      return;
    }

    const allowedTypes = ["image/png"];
    const maxSize = 0.5 * 1024 * 1024; // 1MB limit

    if (!allowedTypes.includes(file.type)) {
      setIconPreview(null);
      setUploadedImage(null);
      setFileError("Only PNG files are allowed.");
      return;
    }
    // Check the file size
    if (file.size > maxSize) {
      setIconPreview(null);
      setUploadedImage(null);
      setFileError("File size must be less than 500KB.");
      return;
    }
    const iconUrl = URL.createObjectURL(file);
    setIconPreview(iconUrl);

    setUploadedImage(file);
    setFileError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!uploadedImage) {
        alert(fileError || "Please select an icon of type PNG.");
        return;
      }

      const formData = new FormData();
      formData.append("icon", uploadedImage);
      formData.append("itemName.en", roomTypeName.en);
      formData.append("itemName.ar", roomTypeName.ar);
      formData.append("status", isChecked);

      const response = await CreateRoomType(formData);
      if (response) {
        toast.success("Room Type Created Successfully");
        navigate("/room-type");
      } else {
        toast.error("Room Type Creation Failed");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }
  };
  return (
    <React.Fragment>
      <div className="page-content">
      <Container className="px-0 dark:bg-darkBg1 dark:text-[#c7d8eb]" fluid>
        <Breadcrumbs title="Add Room Type" breadcrumbItems={breadcrumbItems} />
        <div className="p-6 flex flex-col gap-6 ">
          <h1 className="text-2xl dark:text-[#c7d8eb]">Add Room Type</h1>
          <div className="lg:flex flex-col w-full lg:max-w-4xl mx-auto p-4 lg:rounded-lg lg:border border-gray-400 dark:border-white">
            <AvForm onValidSubmit={handleSubmit}>
              <div className="mb-3">
                <AvField
                  className="dark:!bg-darkBg1 dark:!text-[#c7d8eb] dark:!border-white dark:placeholder:!text-[#c7d8eb]"
                  name="itemNameEn"
                  label="Room Type Name In English"
                  placeholder="Type room type name In English (e.g., Shared Room)"
                  type="text"
                  errorMessage="Enter Name In English"
                  validate={{ required: { value: true } }}
                  onChange={(e) =>
                    setRoomTypeName((prev) => ({
                      ...prev,
                      en: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="mb-3">
                <AvField
                  className="dark:!bg-darkBg1 dark:!text-[#c7d8eb] dark:!border-white dark:placeholder:!text-[#c7d8eb]"
                  name="itemNameAr"
                  label="Room Type Name In Arabic"
                  placeholder="Type room type name In Arabic (e.g., غرفة مشتركة)"
                  type="text"
                  errorMessage="Enter Name In Arabic"
                  validate={{ required: { value: true } }}
                  onChange={(e) =>
                    setRoomTypeName((prev) => ({
                      ...prev,
                      ar: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="mb-3">
                {iconPreview && (
                  <img
                    src={iconPreview}
                    alt="Preview"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "contain",
                    }}
                  />
                )}
                <AvField
                  className="dark:!bg-darkBg1 dark:!text-[#c7d8eb] dark:!border-white dark:placeholder:!text-[#c7d8eb]"
                  name="icon"
                  type="file"
                  accept="image/png"
                  label="Upload an Icon"
                  onChange={handleImageUpload}
                  errorMessage={fileError || "Please upload an icon."}
                  validate={{
                    required: { value: true },
                    // Add a fake validator to make AvField always revalidate correctly
                    pattern: {
                      value: ".*",
                      errorMessage: fileError || "Please upload an icon.",
                    },
                  }}
                />
              </div>
              <h4 className="text-base dark:text-[#c7d8eb]">Status</h4>
              <div className="form-check form-switch mb-3" dir="ltr">
                <Input
                  type="checkbox"
                  className="form-check-input"
                  onChange={() => setIsChecked((prev) => !prev)} // Toggle the state on change
                  id="customSwitch1"
                  defaultChecked={isChecked} // Set the default checked state
                  checked={isChecked} // Control the checked state
                />

                <Label
                  className="form-check-label"
                  htmlFor="customSwitch1"
                  onClick={(e) => {
                    this.setState({ toggleSwitch: !this.state.toggleSwitch });
                  }}
                >
                  {isChecked ? "Active" : "Inactive"}
                </Label>
              </div>

              <FormGroup className="mb-0">
                <div>
                  <Button type="submit" color="primary" className="me-1">
                    Add
                  </Button>{" "}
                </div>
              </FormGroup>
            </AvForm>
          </div>
        </div>
      </Container>
      </div>
    </React.Fragment>
  );
};

export default AddRoomType;
